module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-table/~/babel-runtime/core-js/object/define-property.js
 ** module id = 1912
 ** module chunks = 3
 **/